import { Grid } from "@mui/material";
import { Actions } from "../Modal";
import { Form, Input, Submit } from "../Form";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { createSupervision, editSupervision } from "../../features/supervision/supervisionSlice";

const properties = { id: '', nombre: '', clave: '' };

const Forms = () => {
    const { id, openModalEdit } = useSelector(state => state.modal);
    const { supervision } = useSelector(state => state.supervision)
    const dispatch = useDispatch()
    const methods = useForm({ shouldUnregister: true })
    const data = openModalEdit ? supervision.find(el => el.id === id) : properties;
    const onSubmit = values => dispatch(openModalEdit ? editSupervision({ id, values, setError: methods.setError }) : createSupervision({ values, setError: methods.setError }))
    return(
        <Actions title={openModalEdit ? 'Editar' : 'Crear Supervisión'}>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input name={'clave'} label={'Clave'} val={ data.clave } min={2} max={6} regEx={/[A-Z]/ig}/>
                    <Input name={'nombre'} label="Nombre" val={ data.nombre }/>
                    <Submit title={openModalEdit ? 'Guardar cambios' : 'Registrar'} />
                </Grid>
            </Form>
        </Actions>
    )
}

export default Forms;